import { Box, Button, Stack, Typography } from '@mui/material';
import { LogosHeader } from '../../components/LogosHeader';

/**
 * Skeleton component displayed when data synchronization has failed
 *
 * Displays when the app cannot retrieve data (UNAVAILABLE state):
 * - Never synchronized before + an error occurred during initialization
 * - Service Worker cold-started on mobile and sync data was lost
 *
 * Features:
 * - Real logos (HandiToit, AG2R) - consistent with other skeletons
 * - Clear message indicating data unavailability
 * - Explanation of what happened
 * - "Retry" button to reload and attempt recovery
 *
 * Auto-recovery is already in progress via SW initialize() call
 */
export const UnavailableSkeleton = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        textAlign: 'center',
        py: 2,
        px: 1
      }}
    >
      {/* Logos section */}
      <LogosHeader sx={{ mb: 2 }} />

      {/* Message section */}
      <Stack spacing={2} sx={{ width: '100%', maxWidth: '400px', mt: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500 }}>
          Données non disponibles
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          La synchronisation n'a pas abouti. Vérifiez votre connexion réseau et réessayez.
        </Typography>

        {/* Retry button */}
        <Button variant="contained" onClick={handleRetry} sx={{ mt: 2 }}>
          Réessayer
        </Button>
      </Stack>
    </Box>
  );
};
